module.exports = __webpack_public_path__ + "img/icon-subjects.ac578b36.svg";